import React, { SVGProps } from "react";

const CrossOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.88281 2.4213L8.00014 6.53863L12.0961 2.44263C12.1866 2.34633 12.2956 2.2693 12.4166 2.21614C12.5376 2.16299 12.668 2.13481 12.8001 2.1333C13.083 2.1333 13.3544 2.24568 13.5544 2.44572C13.7544 2.64576 13.8668 2.91707 13.8668 3.19997C13.8693 3.33074 13.845 3.46065 13.7955 3.58171C13.746 3.70277 13.6722 3.81243 13.5788 3.90397L9.42947 7.99997L13.5788 12.1493C13.7546 12.3213 13.8577 12.5542 13.8668 12.8C13.8668 13.0829 13.7544 13.3542 13.5544 13.5542C13.3544 13.7543 13.083 13.8666 12.8001 13.8666C12.6642 13.8723 12.5286 13.8496 12.4019 13.8C12.2752 13.7504 12.1602 13.675 12.0641 13.5786L8.00014 9.4613L3.89347 13.568C3.80335 13.6611 3.69568 13.7354 3.57668 13.7866C3.45768 13.8379 3.3297 13.8651 3.20014 13.8666C2.91724 13.8666 2.64593 13.7543 2.44589 13.5542C2.24585 13.3542 2.13347 13.0829 2.13347 12.8C2.13099 12.6692 2.15525 12.5393 2.20478 12.4182C2.2543 12.2972 2.32804 12.1875 2.42147 12.096L6.57081 7.99997L2.42147 3.85063C2.24567 3.67864 2.14258 3.44574 2.13347 3.19997C2.13347 2.91707 2.24585 2.64576 2.44589 2.44572C2.64593 2.24568 2.91724 2.1333 3.20014 2.1333C3.45614 2.1365 3.70147 2.23997 3.88281 2.4213Z"
      fill="black"
    />
  </svg>
);

export default CrossOutline;
